module.exports = __webpack_public_path__ + "img/Soga-om-Gunnlaug-Ormstunge_Siste-bilde.8203a7bd.jpg";